import { createAsyncThunk, createSlice, isAsyncThunkAction,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { TimeOffTypeStateClass } from "./interfaces/TimeOffTypeStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: TimeOffTypeStateClass = {
    isLoading: false,
    TimeOffTypeList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    TimeOffTypeAuditList:[],
    employeeName : '',
    departmentName :'',
    locationName : '',
    policyName : '',
    sortOrder: 'asc',
    sortColumn: 'AccountTimeOffType',
    search: '',
    pageNo: 1,
    pageSize: 10

};

interface IThunkApi {
    state: {
        timeOffType: TimeOffTypeStateClass
    }
};

export const getAccountTimeOffTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "TimeOffType/getAccountTimeOffType",
        async (arg, thunkApi) => {

            //const response = await fetchAPI("api/TimeOffTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/V2/TimeOffTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }

    )
export const getAccountTimeOffTypeByTimeOffTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffType/getAccountTimeOffTypeByTimeOffTypeId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TimeOffTypes/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/V2/TimeOffTypes/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const getEmployeeTimeOffAuditAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffType/getEmployeeTimeOffAudit",
        async (arg, thunkApi) => {
            const { AccountTimeOffTypeId,AccountEmployeeId } = arg;
            const response = await fetchAPI('api/V2/TimeOffTypes/EmployeeTimeOffAudit/' + AccountEmployeeId +'/' + AccountTimeOffTypeId, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const addAccountTimeOffTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffType/addAccountTimeOffType',
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TimeOffTypes/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/V2/TimeOffTypes/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountTimeOffTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffType/updateAccountTimeOffType',
        async (arg, thunkApi) => {
            //const {AccountLocationId} = arg;
            const { AccountTimeOffTypeId, ...argWithoutId } = arg;
            //const response = await fetchAPI('api/TimeOffTypes/' + AccountTimeOffTypeId, 'POST', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/V2/TimeOffTypes/' + AccountTimeOffTypeId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountTimeOffTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffType/deleteAccountTimeOffType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TimeOffTypes/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/V2/TimeOffTypes/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const DeleteSelectedAccountTimeOffTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffType/v2/DeleteSelectedAccountTimeOffType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/v2/Status/DeleteSelected/','Delete',arg,true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/TimeOffTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const timeOffTypeSlice = createSlice({
    name: "timeOffType",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.TimeOffTypeList.findIndex((item) => item.AccountTimeOffTypeId == action.payload);
            const newArray = [...state.TimeOffTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.TimeOffTypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.TimeOffTypeList.findIndex((item) => item.AccountTimeOffTypeId == action.payload);
            const newArray = [...state.TimeOffTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.TimeOffTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.TimeOffTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.TimeOffTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.TimeOffTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.TimeOffTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.TimeOffTypeList;
            state.TimeOffTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountTimeOffTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountTimeOffTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.TimeOffTypeList = [];
                } else {
                    state.TimeOffTypeList = payload.Data;
                    state.TimeOffTypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.TimeOffTypeList = payload.Data;
                state.TimeOffTypeList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountTimeOffTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })



            .addCase(getAccountTimeOffTypeByTimeOffTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountTimeOffTypeByTimeOffTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isLoading = false;
            })
            .addCase(getAccountTimeOffTypeByTimeOffTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getEmployeeTimeOffAuditAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getEmployeeTimeOffAuditAsync.fulfilled, (state, { payload }) => {
    state.status = 'idle';
   
    
    if (payload.Data.length === 0) {
        state.TimeOffTypeAuditList = [];
    } 
    else {
        const parsedData = JSON.parse(payload.Data);
        state.TimeOffTypeAuditList = parsedData.map((row:any) => {
            if (row["ExecutionType"] === "System" || row["ExecutionType"] === "") {
                return {
                    ...row,
                    ModifiedByEmployeeName: "" 
                };
            }
            return row;
        });
    }   
    state.employeeName = payload.employeeName;
    state.departmentName = payload.departmentName;
    state.locationName = payload.locationName;
    state.policyName = payload.policyName ? payload.policyName : '';
    
    state.isLoading = false;
})
            .addCase(getEmployeeTimeOffAuditAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(addAccountTimeOffTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountTimeOffTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountTimeOffTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountTimeOffTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountTimeOffTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountTimeOffTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountTimeOffTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountTimeOffTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountTimeOffTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(DeleteSelectedAccountTimeOffTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountTimeOffTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountTimeOffTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
});

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting } = timeOffTypeSlice.actions
export const timeOffTypeState = (state: RootState) => state.timeOffType
export default timeOffTypeSlice.reducer


